var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import ErrorScreen from "./ErrorScreen";
import RouteLoading from "./RouteLoading";
// h/t: https://github.com/bvaughn/react-error-boundary
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: null,
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        var onError = this.props.onError;
        if (typeof onError === "function") {
            try {
                /* istanbul ignore next: Ignoring ternary; can’t reproduce missing info in test environment. */
                onError.call(this, error, (info === null || info === void 0 ? void 0 : info.componentStack) ? info.componentStack : "");
            }
            catch (ignoredError) {
                // we're ignoring this error
            }
        }
        this.setState({ error: error });
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.props, children = _a.children, ErrorComponent = _a.ErrorComponent, onCloseRequested = _a.onCloseRequested;
        var error = this.state.error;
        return error === null ? (children) : (React.createElement(React.Suspense, { fallback: React.createElement(RouteLoading, null) },
            React.createElement(ErrorComponent, { onCloseRequested: onCloseRequested })));
    };
    ErrorBoundary.defaultProps = {
        ErrorComponent: ErrorScreen,
    };
    return ErrorBoundary;
}(React.PureComponent));
export default ErrorBoundary;
